import * as React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { ThemeTextSize } from '.';
import AppService, { textsize } from '../services/app.service';

interface Props {
  id?: string;
  name: string;
  label?: string;
  placeHolder?: string;
  value: string;
  size?: textsize;
  autoSelect?: boolean;
  box?: boolean;
  color?: any;
  readOnly?: boolean;
  disableMargin?: boolean;
  onChange?: (fieldName: string, value?: string) => void;
  error?: string;
}

export const InputColor: React.FunctionComponent<Props> = (props) => {
  const [value, setValue] = React.useState<string>('#34b1fd');
  const isMobile = AppService.isMobile();

  const fontSize = (size?: textsize) => {
    return ThemeTextSize(size || props.size).fontSize;
  }

  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => { 
    props.onChange?.(props.name, value);
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => { 
    props.onChange?.(props.name, e?.target.value);
  }
  
  React.useEffect(() => {  
    if (/^#[0-9A-F]{6}$/i.test(props.value)) setValue(props.value);
  },[props.value])

  return (
    <TextField
      id={props.id || props.name}
      name={props.name}
      label={props.label}
      type='input'
      value={props.value || value}
      placeholder={props.placeHolder}
      inputProps={{spellCheck: false}}
      InputProps={{
        readOnly: props.readOnly || false,
        sx: {fontSize: fontSize(), bgcolor: props.color, borderRadius: 3, marginTop: props.box? 1.5 : 0},
        endAdornment: 
          <InputAdornment position='start' sx={{width: 30, mr: 0, mb: 1}}>
            <input name={props.name} type='color' value={value} onChange={onChange}/>
          </InputAdornment>,
      }}
      InputLabelProps={{
        shrink: true,
        sx: {fontSize: fontSize() + (isMobile? 0 : 2), left: props.box? -7 : 0}
      }}
      FormHelperTextProps={{
        sx: {fontSize: fontSize(isMobile? 'medium' : 'small')}
      }}
      sx = {{'& legend': {width: props.box? 0 : undefined}}}
      margin={props.disableMargin? 'none' : 'normal'}
      variant={props.box? undefined : 'standard'}
      fullWidth
      helperText={props.error}
      error= {props.error? true: false}
      onBlur={onBlur}
      onChange={onChange}
    />
  )

  
}